import styled from 'styled-components';
import {theme} from '@styles/theme';

export const SidebarWrapper = styled.div<{collapsed: boolean}>`
  width: ${({collapsed}) => (collapsed ? '48px' : '224px')};
  background-color: ${theme.colors.basic08};
  display: flex;
  flex-direction: column;
  transition: all 0.2s linear;
`;

export const LogoWrapper = styled.div<{collapsed: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({collapsed}) => (collapsed ? '64px 9px 40px' : '64px 16px 40px')};
  border-bottom: 1px solid ${theme.colors.basic06};
  cursor: pointer;
`;

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 8px 8px;
`;

export const MenuItemWrapper = styled.div<{
  active?: boolean;
}>`
  display: flex;
  gap: 14px;
  padding: 12px 8px;
  border-radius: ${theme.roundedMedium};
  background-color: ${({active}) => (active ? theme.colors.basic07 : theme.colors.basic08)};
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  &:hover {
    background-color: ${theme.colors.basic07};
  }
`;

export const CollapsedSidebarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;
